import React, {useState} from 'react';
import classes from './MoveToTopButton.css';
import ReactTooltip from 'react-tooltip';
const MoveToTopButton = () =>{

const [visible, setVisible] = useState(false)

const toggleVisible = () => {
	const scrolled = document.documentElement.scrollTop;
	if (scrolled > 300){
	setVisible(true)
	}
	else if (scrolled <= 300){
	setVisible(false)
	}
};

const scrollToTop = () =>{
	window.scrollTo({
	top: 0,
	behavior: 'smooth'
	});
};

window.addEventListener('scroll', toggleVisible);

return (
	<div className={classes.buttonClass}>
		<button data-tip data-for='moveToTop' onClick={scrollToTop} style={{display: visible ? 'inline' : 'none'}} >
			<span class="glyphicon glyphicon-chevron-up"></span>
			<ReactTooltip id='moveToTop'>
            <span>Move To Top</span>
          </ReactTooltip>
		</button>
	</div>
);
}

export default MoveToTopButton;
